import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-restaurant-hours',
  templateUrl: './restaurant-hours.component.html',
  styleUrls: ['./restaurant-hours.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RestaurantHoursComponent {
  @Input() isOpen = false;
  @Input() openedAt?: Date;
  @Input() closedAt?: Date;
}
